import {ShopIcon} from './ShopIcon';

export function BrandedButtonIcon() {
  return (
    <ShopIcon className="flex aspect-branded-button-icon h-branded-button-icon w-auto translate-y-[9.375%] self-center" />
  );
}

BrandedButtonIcon.displayName = 'BrandedButtonIcon';
